import * as R from 'ramda';

const RequestHelper = {
    requestSucceeded: R.pipe(R.path(['data', 'error']), R.isNil)
};

export default RequestHelper;



// WEBPACK FOOTER //
// ./common/request_helper.js